// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Hole counts a round can be played over. 9 and 18 are the real-world options; 3 is a
// developer-only shortcut so a round can be played to the end in a few taps while testing.
//
// The read side (round metadata coming back from the server) accepts all three regardless of
// role — a 3-hole round created by a developer still has to render for everyone else in it.
// Only the pickers that *create* a round are role-gated, via `holesCountOptions()`.

export const HOLES_COUNT_OPTIONS = [9, 18] as const;
export const DEVELOPER_HOLES_COUNT_OPTIONS = [3, 9, 18] as const;
export const DEFAULT_HOLES_COUNT = 18;

/** True for a hole count the backend stores as-is (anything else is normalized to 18). */
export const isValidHolesCount = (value: unknown): value is number => value === 3 || value === 9 || value === 18;

/** Options to offer in a round-creation picker. Developers also get the 3-hole test round. */
export const holesCountOptions = (isDeveloper: boolean): readonly number[] =>
  isDeveloper ? DEVELOPER_HOLES_COUNT_OPTIONS : HOLES_COUNT_OPTIONS;

/** Coerce a value read from the server (number or string) to a supported hole count. */
export const normalizeHolesCount = (value: unknown): number => {
  const parsed = typeof value === 'number' ? value : Number(value);
  return isValidHolesCount(parsed) ? parsed : DEFAULT_HOLES_COUNT;
};
